// Defines global constants
export default {
    scheme              : 'https://',
    feedRefURL          : '/ccp-webapp/ccp/feed/',
    chatURI             : '/ccp/chat',
    chatEventsPathParam : '?all=false&eventid=',
    locationHeader      : 'Location',
    xmlMIMEType         : 'application/xml',
    ccx_chat_csq_tag    : 'Chat_Csq'
};
